<template>
  <div class="index-page__back-to-top">
    <span class="back-to-top-link subhead" @click="onClick">
      ページトップへ ▲
    </span>
  </div>
</template>
<script>
export default {
  methods: {
    onClick() {
      this.$emit('click-link')
    }
  }
}
</script>
<style lang="scss" scoped>
.index-page__back-to-top {
  margin-top: 24px;
  padding: 16px;
  text-align: center;
  background-color: $gray-2;

  .back-to-top-link {
    @extend %hover-common;
    box-sizing: border-box;
    display: inline;
    color: $link;
    cursor: pointer;
  }
}
</style>
